import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  getUserLastActionData,
  SEND_PRODUCTS_COMPARE_ACTION,
  RETRY_LAST_COMPARE_ACTION,
  MANAGE_PRODUCT_IN_COMPARE_LIST,
  CompareActions,
} from 'features/products-compare';
import { CompareStatusMode } from '../utils';

type UseCompareActionsParams = {
  skipDataLoading?: boolean;
};

export const useCompareActions = ({ skipDataLoading = false }: UseCompareActionsParams) => {
  const dispatch = useDispatch();
  const userLastActionData = useSelector(getUserLastActionData);

  const handleRestoreProduct = useCallback(() => {
    const { productId, familyId, groupName, productIds, action } = userLastActionData;

    dispatch(
      SEND_PRODUCTS_COMPARE_ACTION({
        action: CompareActions.ADD,
        productId,
        familyId,
        groupId: familyId,
        groupName,
      }),
    );

    dispatch(
      MANAGE_PRODUCT_IN_COMPARE_LIST({
        action: CompareActions.ADD,
        productId,
        familyId,
        groupName,
        withData: !skipDataLoading,
        productIds: action === CompareActions.DELETE_GROUP ? productIds : undefined,
      }),
    );
  }, [userLastActionData, skipDataLoading]);

  const handleRetryAction = useCallback(() => {
    dispatch(RETRY_LAST_COMPARE_ACTION());
  }, []);

  const handleButtonClick = useCallback(
    (mode: CompareStatusMode) => {
      if (!mode || mode === 'added') return;

      switch (mode) {
        case 'removed':
          handleRestoreProduct();
          break;
        case 'error':
          handleRetryAction();
          break;
      }
    },
    [handleRestoreProduct, handleRetryAction],
  );

  return {
    handleButtonClick,
    handleRestoreProduct,
    handleRetryAction,
  };
};
